<div class="component text-center phone-verification">
  <div class="phone-verification-overlay"></div>
  <div class="card">
    <p>Please verify your phone number.</p>
    <p>We will send you a SMS message (valid for 5 minutes.)</p>
    <form>
      <div class="form-group">
        <label for="phone">Your phone:</label>
        <input type="tel" id="phone" disabled class="form-control" name="phone" [ngModel]="currentUser.phone.value">
      </div>
      <button *ngIf="!isSuccessful && !isActivated" type="submit" class="btn send-button" (click)="sendSms()">
        Send SMS
      </button>
    </form>
    <form *ngIf="isSuccessful && !isActivated" name="codeForm"
          (ngSubmit)="f.form.valid && onSubmitCode()"
          #f="ngForm" novalidate>
      <div class="form-group">
        <label for="code">Enter code from SMS message:</label>
        <input type="tel" id="code" class="form-control" name="code" [(ngModel)]="activationCode">
      </div>
      <button type="submit" class="btn verify-button">Verify</button>
    </form>
    <p *ngIf="isActivated">Your phone was verified</p>
  </div>
</div>
